import React from "react";
import { Box, Group, Stack, Text } from "@mantine/core";
import {
  IconAlertTriangle,
  IconCircleCheck,
  IconCircleX,
  IconInfoCircle,
} from "@tabler/icons-react";
import { Check, CheckStatus } from "../helpers/lnurlPayTest";

export const STATUS_COLORS: Record<CheckStatus, string> = {
  pass: "#4ade80",
  fail: "#f87171",
  warn: "#fbbf24",
  info: "#60a5fa",
};

const STATUS_ICONS: Record<CheckStatus, React.FC<any>> = {
  pass: IconCircleCheck,
  fail: IconCircleX,
  warn: IconAlertTriangle,
  info: IconInfoCircle,
};

const CheckList: React.FC<{ checks: Check[] }> = ({ checks }) => (
  <Stack gap={10}>
    {checks.map((check, index) => {
      const Icon = STATUS_ICONS[check.status];
      return (
        <Group key={index} gap="sm" wrap="nowrap" align="flex-start">
          <Icon
            size={20}
            color={STATUS_COLORS[check.status]}
            style={{ flexShrink: 0, marginTop: 1 }}
          />
          <Box style={{ minWidth: 0 }}>
            <Text size="sm" c="white" style={{ lineHeight: 1.45 }}>
              {check.label}
            </Text>
            {check.detail && (
              <Text
                size="xs"
                c="dimmed"
                mt={2}
                style={{ lineHeight: 1.5, overflowWrap: "anywhere" }}
              >
                {check.detail}
              </Text>
            )}
            {check.fix && (
              <Text size="xs" mt={2} style={{ lineHeight: 1.5, color: "#fdba74" }}>
                Fix: {check.fix}
              </Text>
            )}
          </Box>
        </Group>
      );
    })}
  </Stack>
);

export default CheckList;
